import { render } from "./views/TransactionConfirm.html?vue&type=template&id=13f74678&external"
import script from "./TransactionConfirm.vue?vue&type=script&lang=js"
export * from "./TransactionConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__